/**
 * Created by bszggg on 2019. 06. 15..
 */
import moment from 'moment';
import SettingsContainer from '@/helper/SettingsContainer';

/**
 * Helper General functions for all of product parts
 */
const Helper = {
  default_type: "",
  default_presuf: "",
  default_fix: "",
  default_lang: "",
  base_item: "gross", // net gross

  price_number_of_decimals: 2,
  discount_number_of_decimals: 2,
  sumprice_number_of_decimals: 2,
  defaultdtpaymentdeadline: 2,
  ggg: "",

  String: function (data) {
    let retString = String(data);
    if (String(data) === "null") {
      retString = "";
    }
    if (String(data) === "undefined") {
      retString = "";
    }
    if (String(data) === "[object Object]") {
      retString = "";
    }
    return retString
  },
  Number: function (num, covertToString) {
    let retNum = 0;
    try {
      retNum = Number(num);
    } catch (e) {
      retNum = 0;
    }
    if (isNaN(retNum)) {
      retNum = 0;
    }
    if (covertToString) {
      retNum = Helper.String(retNum)
    }
    return retNum
  },
  roundToProjectDecimal: function (num) {
    return Math.round(num * 100) / 100
  },

  getDefaultdtpaymentdeadline: function (data, keys) {
    return Helper.Number(this.defaultdtpaymentdeadline);
  },
  makeFilteredObjectByKeys: function (data, keys) {
    const ret = {};
    if (Array.isArray(keys)) {
      Array.prototype.forEach.call(keys, function (e) {
        ret[e] = data[e];
      })
    }
    return ret;
  },
  getNewUTCDateTime: function () {
    // const date = new Date();
    // return date.toUTCString();
    return moment.utc().format('YYYY-MM-DD HH:mm:ss');
  },
  getDisplaUTCDateTime: function (datestring, format = 'YYYY-MM-DD HH:mm:ss') {
    if (typeof datestring === "string") {
      const dateObj = moment.utc(datestring).local();
      return dateObj.format(format)
    }
  },
  sortObjectOfArrayByKey: function (objectOfArray, key) {
    objectOfArray.sort((a, b) => (a.key > b.key) ? 1 : -1)
    return objectOfArray;
  },
  sortObjectOfArrayByKeyWithLocale: function (objectOfArray, key, lang = "en", additionalParams = {}, ascdesc = "asc") {
    const collator = new Intl.Collator(lang, Object.assign({
      sensitivity: 'accent'
      , caseFirst: false
    }, additionalParams));
    objectOfArray.sort(function (a, b) {
      if (ascdesc === "asc") {
        return collator.compare(a[key], b[key])
      } else {
        return collator.compare(b[key], a[key])
      }
    });
    return objectOfArray;
  },
  getUrlParamsByName: function (paramName) {
    const url = new URL(window.location.href);
    const value = url.searchParams.get(paramName);
    console.log(value);
    return value;
  },

  checkAppVersion: function (neededAppVersion, actualAppVersion) {
    let hastoRefresh = false;
    const arrNeededAppVersion = neededAppVersion.split(".");
    const arrActualAppVersion = actualAppVersion.split(".");
    if (arrNeededAppVersion.length === 3 && arrActualAppVersion.length === 3) {
      if (Helper.Number(arrNeededAppVersion[0]) > Helper.Number(arrActualAppVersion[0])) {
        hastoRefresh = true;
      } else {
        if (Helper.Number(arrNeededAppVersion[1]) > Helper.Number(arrActualAppVersion[1])) {
          hastoRefresh = true;
        } else {
          if (Helper.Number(arrNeededAppVersion[2]) > Helper.Number(arrActualAppVersion[2])) {
            hastoRefresh = true;
          }
        }
      }
    }
    return hastoRefresh;
  },
  printElement: function (idElement, strStyle) {
    const mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('</head><body >');
    // mywindow.document.write('<h1>' + document.title + '</h1>');
    mywindow.document.write(document.getElementById(idElement).innerHTML);
    mywindow.document.write('<style>'+strStyle+'</style>');
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  },

// list.sort((a, b) => (a.color > b.color) ? 1 : (a.color === b.color) ? ((a.size > b.size) ? 1 : -1) : -1 )
//   focusNextInputElement: function () {
//     //add all elements we want to include in our selection
//     var focussableElements = ' input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'; // a:not([disabled]), button:not([disabled]),
//     if (document.activeElement && document.activeElement.form) {
//       var focussable = Array.prototype.filter.call(document.activeElement.form.querySelectorAll(focussableElements),
//         function (element) {
//           //check for visibility while always include the current activeElement
//           return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
//         });
//       var index = focussable.indexOf(document.activeElement);
//       if (index > -1) {
//         var nextElement = focussable[index + 1] || focussable[0];
//         nextElement.focus();
//       }
//     } else if (document.activeElement && !document.activeElement.form) {
//       var focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
//         function (element) {
//           //check for visibility while always include the current activeElement
//           return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
//         });
//       var index = focussable.indexOf(document.activeElement);
//       if (index > -1) {
//         var nextElement = focussable[index + 1] || focussable[0];
//         nextElement.focus();
//       }
//     }
//   },
  getfocusNextInputElement: function (activeElement) {
    //add all elements we want to include in our selection
    const focussableElements = ' input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'; // a:not([disabled]), button:not([disabled]),
    if (!activeElement) {
      activeElement = document.activeElement;
    }
    if (activeElement && activeElement.form) {
      const focussable = Array.prototype.filter.call(activeElement.form.querySelectorAll(focussableElements),
        function (element) {
          //check for visibility while always include the current activeElement
          return element.offsetWidth > 0 || element.offsetHeight > 0 || element === activeElement
        });
      const index = focussable.indexOf(activeElement);
      if (index > -1) {
        const nextElement = focussable[index + 1] || focussable[0];
        // nextElement.focus();
        return nextElement
      }
    } else if (activeElement && !activeElement.form) {
      const focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
        function (element) {
          //check for visibility while always include the current activeElement
          return element.offsetWidth > 0 || element.offsetHeight > 0 || element === activeElement
        });
      const index = focussable.indexOf(activeElement);
      if (index > -1) {
        const nextElement = focussable[index + 1] || focussable[0];
        return nextElement
      }
    }
  },


  /**
   * A bejelentkezett usernek van-e joga az adott funkcióhoz a saját role-ja alapján
   * @param roles
   * @param user_role
   * @returns {boolean}
   */
  checkRoles: function (roles, user_role = null) {
    // console.log("checkRoles")
    // console.log(roles)
    // console.log(user_role)
    if (Array.isArray(roles)) {
      let rights = false;
      Array.prototype.forEach.call(roles, function (role) {
        // if (role === 0) {
        //     rights = true;
        // }
        if (user_role !== null && user_role.toString() === role.toString()) {
          rights = true;
          // } else if (window.user && window.user.user_role && role && window.user.user_role.toString() === role.toString()) {
          //   rights = true;
        }
      });
      // console.log("rights");
      // console.log(rights);
      return rights;
    }
  },
  chkRole(modul){
    // const modul = this;
    modul.hasRole = false;
    const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
    if (!Helper.checkRoles(modul.roles, role)) {
      modul.hasRole = false;
//        modul.$router.push({name: "dashboard"})
    } else {
      modul.hasRole = true;
    }
  },

  // user_role -> Ez az user tábla role- mezője
  // partneruserroleId => ez az amit az user role-ú felhasználó adatlapján pipál6unk.. aljogosultságok
  //
  // checkRolesAuto(this, modul tábla azonosító , role tábla azonosító)
  // checkRolesAuto(this, 3,1)               ha admin, és a 3-as modulhoz van joga a cégnek akkor ok,  ILLETVE ha user joga van akkor partneruserrole alapján kell lennie 1-esnek és akkkor oké
  // checkRolesAuto(this, [1,10],13)         Ha admin, és a 1, 10-es modulok valamelyikéhez van joga a cégnek akkor ok, ILLETVE ha user joga van akkor partneruserrole alapján kell lennie 13-esnek és akkkor oké
  //
  // checkRoles([5, 6, 7, 8, 9, 10], user_role)   a user_role benne van-e a felsoroltak között

  /**
   * ha modulId===null akkor nem vizsgáljuk a modul szerinti jogosultságot
   *
   * @param modul
   * @param modulId : int, OR array of int - contains modulId
   * @param partneruserroleId
   * @returns {boolean}
   *
   * paramétererk:   Modul  ,  Modul id vagy modul id-k amikhez ez a cucc tartozik  ,  a minimum user role, ami felett hozzáférhetnek
   */

  checkRolesAuto: function (modul, modulId, partneruserroleId) {
    const user_role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
    const partneruserroles = (modul.$store.state && modul.$store.state.partneruserroles ) ? modul.$store.state.partneruserroles : [];
    const moduleRights = (modul.$store.state && modul.$store.state.moduleRights ) ? modul.$store.state.moduleRights : [];

    const partneruserrolesIds = [];
    if (Array.isArray(partneruserroles)) {
      partneruserroles.forEach(function (e, i) {
        if (Number(e.deleted) === 0 && e.id_role) {
          partneruserrolesIds.push(Number(e.id_role))
        }
      })
    }

    const moduleRightsIds = [];
    if (Array.isArray(moduleRights)) {
      moduleRights.forEach(function (e, i) {
        if (Number(e.id_rights) > 0) {
          moduleRightsIds.push(Number(e.modulid))
        }
      })
    }

    // mdulhoz hozzáférés van-e
    if (Array.isArray(moduleRights)) {
      let rights = false;
      Array.prototype.forEach.call(moduleRights, function (moduleRight) {
        if (moduleRight && Array.isArray(modulId) && modulId.indexOf(Number(moduleRight.modulid)) > -1) {
          rights = true;

        } else if (moduleRight && Number(moduleRight.modulid) === Number(modulId)) { // && modulRoles.indexOf(Number(moduleRight.id_rights)) > -1
          rights = true;
        }
      });
      if (modulId === null) {
        rights = true;
      }
      if (!rights) {
        // console.log("nincs modul jog");
        return false;
      }
    }

    // ha admin, akkor mindent
    if (Number(user_role) >= 8) {
      // console.log("van role - admin alapon");
      return true;
    }
    // ha normál user, akkor partneruser role checks
    if (Number(user_role) === 5) {
      if (partneruserrolesIds.indexOf(Number(partneruserroleId)) > -1) {
        // console.log("van role - user partneruserrole alapon");
        return true;
      }
    }

  },
  getModuleRightsIds: function (modul) {
    const moduleRights = (modul.$store.state && modul.$store.state.moduleRights ) ? modul.$store.state.moduleRights : [];
    const moduleRightsIds = [];
    if (Array.isArray(moduleRights)) {
      moduleRights.forEach(function (e, i) {
        if (Number(e.id_rights) > 0) {
          moduleRightsIds.push(Number(e.modulid))
        }
      })
    }
    return moduleRightsIds;
  },

  /**
   * A bejelentkezett userhez tartozó cégnek van-e joga az adott modulhoz
   * @param moduleRights  Modul szintű jogkör adatok a DB-ből, az adott cégnek
   * @param modulId       Modul azonosítója
   * @param modulRoles    Modulhoz felvitt jogosultségi szint. Most még mindenhol 1-es
   * @returns {boolean}
   */
  hasModuleRights: function (moduleRights, modulId, modulRoles) {
    // console.log("hasModuleRights")
    // console.log(moduleRights)
    // console.log(modulId)
    // console.log(modulRoles)
    // const moduleRights = moduleRights;
    if (Array.isArray(moduleRights)) {
      let rights = false;
      Array.prototype.forEach.call(moduleRights, function (moduleRight) {
        if (moduleRight && Number(moduleRight.modulid) === Number(modulId) && modulRoles.indexOf(Number(moduleRight.id_rights)) > -1) {
          rights = true;
        }
      });
      // console.log(rights)
      return rights;
    }
  },


  getValueByIdAndKeyFromObjectArray: function (key, arr, id, idKey = "id") {
    let ret = null;
    Array.prototype.forEach.call(arr, function (e, i) {
      if (e[idKey].toString() === id.toString()) {
        ret = e[key];
      }
    });
    return ret;
  },
  /**
   * Az object-et adja vissza a tömbből, ahol "idKey" megegyezik az "id"-vel
   * Ez arra jó, hogy kikeressük az adott elemet egy query resultból id alapján
   * @param arr
   * @param id
   * @param idKey
   * @returns {*}
   */
  getObjectByIdFromObjectArray: function (arr, id, idKey = "id") {
    let ret = null;
    Array.prototype.forEach.call(arr, function (e, i) {
      if (e[idKey].toString() === id.toString()) {
        ret = e;
      }
    });
    return ret;
  },
  /**
   * Az object id-jét adja vissza a tömbből, ahol "idKey" megegyezik az "id"-vel
   * Ez arra jó, hogy a tömbbe aláfűzzünk még adatokat. Pl invoice alá az invoice_element-eket
   * @param arr
   * @param id
   * @param idKey
   * @returns {*}
   */
  getObjectIndexByIdFromObjectArray: function (arr, id, idKey = "id") {
    let ret = null;
    Array.prototype.forEach.call(arr, function (e, i) {
      if (e[idKey].toString() === id.toString()) {
        ret = i;
      }
    });
    return ret;
  },
  filterObjectByKeys: function (obj, keys) {
    const ret = {};
    Array.prototype.forEach.call(keys, function (el) {
      if (obj.hasOwnProperty(el)) {
        ret[el] = obj[el];
      }
    });
    return ret;
  },


  // invoice-ból áthozva -- át kell írni az ide megfelelőre
  // Pénznemek
  getMoneyDefaultType: function (date) { // HUF USD EUR
    let ret = "";
    // if (localStorage) {
    // ret = localStorage.getItem("money_default_type");
    ret = Helper.default_type;
    // }
    return ret;
  },
  getMoneyDefaultDisplayPrefix: function (date) { // Ft $ €
    let ret = "";
    // if (localStorage) {
    // let presuf = localStorage.getItem("money_default_presuf");
    let presuf = Helper.default_presuf;
    if (presuf === "prefix") {
      // let fix = localStorage.getItem("money_default_fix");
      let fix = Helper.default_fix;
      ret = fix;
    }
    // }
    return ret;
  },
  getMoneyDefaultDisplaySuffix: function (date) { // Ft $ €
    let ret = "";
    // if (localStorage) {
    // let presuf = localStorage.getItem("money_default_presuf");
    let presuf = Helper.default_presuf;
    if (presuf === "suffix") {
      // let fix = localStorage.getItem("money_default_fix");
      let fix = Helper.default_fix;
      ret = fix;
    }
    // }
    return ret;
  },
  getMoneyDefaultDisplayPreSuf: function () { // Ft $ €
    let ret = "";
    // if (localStorage) {
    // ret = localStorage.getItem("money_default_presuf");
    ret = Helper.default_presuf;
    // }
    return ret;
  },
  getLangDefaultLang: function (date) { // HUF USD EUR
    let ret = "en";
    if (localStorage) {
      ret = localStorage.getItem("lang_default_lang");
    }
    return ret;
  },
  getLang: function (date) { // HUF USD EUR
    let ret = "en";
    if (localStorage) {
      ret = localStorage.getItem("lang");
    }
    return ret;
  },

  updateSettings: function () {
    const data = SettingsContainer.getSettings();
    Helper.setMoneys(data)
  },
  // Ez már a saját cloud oldali függvény a selsettingsből.
  setMoneys(data){
    // const modul = this;
    if (Array.isArray(data)) {

      Array.prototype.forEach.call(data, function (e) {
        if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "money") {
          if (e.typec_sub === "default_type") {
            Helper.default_type = e.valuec;
          }
          if (e.typec_sub === "default_presuf") {
            Helper.default_presuf = e.valuec;
          }
          if (e.typec_sub === "default_fix") {
            Helper.default_fix = e.valuec;
          }
          if (e.typec_sub === "price_number_of_decimals") {
            Helper.price_number_of_decimals = e.valuec;
          }
          if (e.typec_sub === "discount_number_of_decimals") {
            Helper.discount_number_of_decimals = e.valuec;
          }
          if (e.typec_sub === "sumprice_number_of_decimals") {
            Helper.sumprice_number_of_decimals = e.valuec;
          }
          if (e.typec_sub === "defaultdtpaymentdeadline") {
            Helper.defaultdtpaymentdeadline = e.valuec;
          }
          if (e.typec_sub === "base_item") {
            Helper.base_item = e.valuec;
          }
        }
      });
      Array.prototype.forEach.call(data, function (e) {
        if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "lang") {
          if (e.typec_sub === "default_lang") {
            Helper.default_lang = e.valuec;
          }
        }
      });
    }
  },
  getFormattedPrice: function (price) { // HUF USD EUR
    let price_number_of_decimals = 0;
    price_number_of_decimals = Number(Helper.price_number_of_decimals); // Number(localStorage.getItem("price_number_of_decimals"));
    if (isNaN(price_number_of_decimals)) {
      price_number_of_decimals = 0;
    }
    let retPrice = price;
    try {
      let szorzo = Math.pow(10, price_number_of_decimals);
      retPrice = Math.round(price * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(price_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },
  getFormattedDiscount: function (price) { // HUF USD EUR
    let discount_number_of_decimals = 0;
    discount_number_of_decimals = Number(Helper.discount_number_of_decimals); // Number(localStorage.getItem("discount_number_of_decimals"));
    if (isNaN(discount_number_of_decimals)) {
      discount_number_of_decimals = 0;
    }
    let retPrice = price;
    try {
      let szorzo = Math.pow(10, discount_number_of_decimals);
      retPrice = Math.round(price * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(discount_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },
  getFormattedSumprice: function (price) { // HUF USD EUR
    let price_number_of_decimals = 0;
    price_number_of_decimals = Number(Helper.sumprice_number_of_decimals); // Number(localStorage.getItem("sumprice_number_of_decimals"));
    if (isNaN(price_number_of_decimals)) {
      price_number_of_decimals = 0;
    }
    let retPrice = price;
    try {
      let szorzo = Math.pow(10, price_number_of_decimals);
      retPrice = Math.round(price * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(price_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },

  getRoundedNumber: function (number, decimals = 0) { // HUF USD EUR
    let retPrice = number;
    try {
      let szorzo = Math.pow(10, decimals);
      retPrice = Math.round(number * szorzo) / szorzo;
      // retPrice=Number(price).toFixed(price_number_of_decimals);
    } catch (e) {
    }
    return retPrice;
  },
  pad: function (number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  },
  // BROWSER IDENTIFIER HANDLING
  getBrowserIdentifier: function () {

  },
  setBrowserIdentifier: function () {

  },
  machineIdSync: function () {
    const browserIdentifier = localStorage.getItem("browserIdentifier");
    const wsid =(browserIdentifier)?browserIdentifier:"";
    // console.log(wsid);
    return wsid;
  }


};

export default Helper;
